"use client";

import { Chip, IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/HelpOutline";
import { TableRow, TableCell, Avatar } from "@/ui";
import ImportHelp from "@components/shared/modals/ImportHelp";
import { useState } from "react";
import Link from "next/link";
import isPlaceholderPhoto from "@lib/candidates/isPlaceholderPhoto";

export default function FailedRow({ candidate }) {
  const [openHelp, setOpenHelp] = useState(false);

  return (
    <TableRow>
      <TableCell>
        <Avatar
          src={isPlaceholderPhoto(candidate.photo_url) ? undefined : candidate.photo_url}
          name={candidate.name}
          size="sm"
        />
      </TableCell>
      <TableCell>
        <Link href={`/candidates/${candidate.uuid}`} style={{ fontWeight: 500, fontSize: 13 }}>{candidate.name}</Link>
      </TableCell>
      <TableCell colSpan={4} style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <Chip label="Failed import" color="error" />
        <IconButton size="small" onClick={() => setOpenHelp(true)}>
          <HelpIcon />
        </IconButton>
      </TableCell>
      <ImportHelp open={openHelp} onClose={() => setOpenHelp(false)} candidateId={candidate?.id} />
    </TableRow>
  );
}
